import {authRequest} from "@/api";

const bashUrl = '/'

/**
 * 登录
 * @param data
 */
export const login = (data) => {
    return authRequest({
        url: `${bashUrl}login`,
        method: 'post',
        data
    })
}
/**
 * 刷新token
 */
export const refreshToken = () => {
    return authRequest({
        url: `${bashUrl}refresh-token`,
        method: 'post'
    })
}


/**
 * 更新用户详情
 */
export const updateUserInfo = () => {
    return authRequest({
        url: `${bashUrl}update-user-info`,
        method: 'get'
    })
}

/**
 * 登录退出
 * @returns {*}
 */
export const loginOut = () => {
    return authRequest({
        url: `${bashUrl}login-out`,
        method: 'post'
    })
}
